<template>
  <div>
    <div v-if="announcements.length === 0" class="center-middle">
      <loading-state />
    </div>
    <div v-else-if="!announcements" class="text-center">
      <EmptyState
        image="announcements"
        :boldMessage="$t('global.no-announcements-bold-message')"
        :message="$t('global.no-announcements-message')"
      />
    </div>
    <div v-else>
      <template v-for="(entry, i) in announcements">
        <div :key="i" v-if="i <= displayIndex">
          <h6 class="mb-3 font-weight-bold">
            {{ dateFormat(entry.post_date) }} - {{ entry.title }}
          </h6>
          <div class="white-space-content">
            {{ entry.body }}
          </div>
          <hr v-if="i < displayIndex" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";
import { dateFormat } from "leatherman-js/utils/formatters/time";
import EmptyState from "@/components/display/empty-state/EmptyState";
import LoadingState from "@/components/display/LoadingState";

export default {
  name: "AnnouncementsDigest",
  components: { EmptyState, LoadingState },
  props: {
    total: {
      type: Number,
      default: 0,
    },
    announcements: {
      type: Array,
    },
  },
  setup(props) {
    const displayIndex = computed(() => {
      const index = Number(props.total) - 1;
      if (index < 0) {
        return 0;
      } else if (index >= 5) {
        return 4;
      }
      return index;
    });

    return {
      dateFormat,
      displayIndex,
    };
  },
};
</script>
